'use strict';
import $ from 'jquery';
import 'jquery-modal';

export default class HubspotMulti {
    static init() {
        $('.hubspot-multi-form').each((index, el) => {
            new HubspotMulti($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.start();
    }

    start() {
        this.submitted = false;

        if (!this.el.attr('id'))
            this.el.attr('id', 'hubspot-form-' + this.makeid(8));
        this.target = this.el.attr('id');

        // this.step = $('.step-heading span.step');

        this.forms = this.el.data('hubspot-form-ids').split(',');
        this.options = [];
        this.data = [];
        this.forms.forEach((form, index) => {
            this.options.push(this.generateFormOptions(form, index));
        });
        // console.log("creating form with ", this.options);
        hbspt.forms.create(this.options[0]);
    }

    generateFormOptions(form, index) {
        const self = this;
        let target = this.target;
        if (this.el.data('popup') && index > 0) {
            const module_id = self.el.data('module-id');
            target = 'inner-popup-' + module_id;
        }
        const formOptions = {
            region: "na1",
            portalId: "6313294",
            formId: form,
            target: '#' + target,
            css: ' ', // required, so that the form is displayed inline, instead of in an iframe, so we can override styles
            onFormSubmit: (form) => {
                self.el.trigger('onFormSubmit');
                if (self.data.length === 0) {
                    const formData = {};
                    self.el.find('[name]').each(function () {
                        if ('hs_context' !== this.name)
                            formData[this.name] = this.value;
                    })
                    self.data.push(formData);
                }

            },
            onFormReady: () => {
                this.el.trigger('onFormReady');

                // Move legal consent to be below the submit button
                let legal_container = this.el.find('.legal-consent-container').parent();
                if (legal_container.is('form')) {
                    legal_container = this.el.find('.legal-consent-container');
                }
                legal_container.insertAfter(this.el.find('.hs-submit'));

                // On all forms except the first one, copy the fields that were filled out on all the previous forms into the new form.
                if (0 !== index) {
                    self.data.forEach((form) => {
                        for (const [key, value] of Object.entries(form)) {
                            $('.form-hero-popup').find('input[name="' + key + '"]').val(value).trigger('change');
                        }
                        // Need to focus or else hubspot erases the email, for some reason. Then hide it.
                        self.el.find('input[name="email"]').focus().closest('.hs_email').hide();
                    });
                }
                this.el.find('input').onClassChange((el, newClass) => {
                    if (newClass.indexOf('invalid') > -1 && newClass.indexOf('error')) {
                        $(el).parent().addClass('error');
                    } else {
                        $(el).parent().removeClass('error');
                    }
                });
            },
        };

        if (this.el.data('url')) {
            formOptions.inlineMessage = ' ';
        }

        formOptions.onFormSubmitted = function (form, redirectUrl, submissionValues) {
            self.el.trigger('onFormSubmitted');
            if (index !== self.forms.length - 1) {
                if (self.el.data('popup') && index === 0) {
                    // If the modal is closed before the last form is submitted, re-initialize everything so the first form shows up again.
                    $('#popup-' + self.el.data('module-id')).on('modal:after-close', (modal) => {
                        if (false === self.submitted) {
                            self.start();
                        }
                    });
                    $('#popup-' + self.el.data('module-id')).modal();
                }
                hbspt.forms.create(self.options[index + 1]);
                // self.step.text(index + 2);
            } else { // last form was submitted
                self.submitted = true;
                if (self.el.data('url')) {
                    window.location = self.el.data('url');
                } else if (self.el.closest('.card-hubspot').find('.thx-msg')) {
                    self.el.closest('.card-hubspot').find('.thx-msg').show();
                }
            }
        };
        return formOptions;
    }

    makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }
}